module.exports = __webpack_public_path__ + "static/img/COC2021-11.ea3d49a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-11.jpg
// module id = x7bP
// module chunks = 0